import { memo, useMemo } from 'react'
import { useField, UseFieldConfig } from 'react-final-form'
import { checkFieldError, getFieldErrorMessage } from 'helpers/form'
import noop from 'lodash/noop'
import { DeliveryTypeEnum } from 'modules/deliveryInfo/types'
import { TScheduleDay } from 'modules/terminal/types'
import { PointInfo } from 'src/store/orderAdd/types'

import { OrderCreateFormDate } from '../components/OrderCreate/OrderCreateFormDate'

interface IProps extends Pick<UseFieldConfig<string>, 'validate'> {
  departureSelectedOption: Pick<NonNullable<PointInfo['selectedOption']>, 'longitude' | 'latitude'>
  departureTerminalId: string
  departureTerminalSchedule: TScheduleDay[] | undefined
  departureType: DeliveryTypeEnum | undefined
  destinationSelectedOption: Pick<NonNullable<PointInfo['selectedOption']>, 'longitude' | 'latitude'>
  destinationTerminalId: string
  destinationTerminalSchedule: TScheduleDay[] | undefined
  destinationType: DeliveryTypeEnum | undefined
  name: string
  className?: string
}

export const FieldOrderCreateFormDate = memo<IProps>(function FieldOrderCreateFormDate({
  className,
  name,
  validate,
  departureTerminalId,
  destinationTerminalId,
  departureType,
  destinationType,
  departureTerminalSchedule,
  destinationTerminalSchedule,
  departureSelectedOption,
  destinationSelectedOption
}) {
  const { input, meta } = useField(name, { validate })

  const error = useMemo(() => getFieldErrorMessage(checkFieldError(meta)), [meta])

  return (
    <div className={className}>
      <OrderCreateFormDate
        clearErrors={noop}
        departureSelectedOption={departureSelectedOption}
        departureTerminalId={departureTerminalId}
        departureTerminalSchedule={departureTerminalSchedule}
        departureType={departureType}
        destinationSelectedOption={destinationSelectedOption}
        destinationTerminalId={destinationTerminalId}
        destinationTerminalSchedule={destinationTerminalSchedule}
        destinationType={destinationType}
        error={error}
        onChange={input.onChange}
        setError={noop}
        value={input.value}
      />
    </div>
  )
})
